<!--     
    ContactCard es un componente donde se listan
    los datos registrados del afiliado
 -->
<template>
    <div>
        <DialogoEditar ref="dialogoEdit" :cabecera="cabecera" :itemsContacto="itemsContacto" :itemGrid="itemGrid" />
        <v-hover v-slot="{ hover }">
            <v-card class="rounded-xl" outlined style="border: 1px solid #eeeeee; cursor: pointer;"
                :elevation="hover ? 5 : 0" @click.stop="listaContactos">
                <v-card-title class="d-flex justify-space-between mx-3 primary--text font-weight-bold"
                    :class="($vuetify.breakpoint.mdAndDown) ? 'text-h6' : 'text-h5'" style="word-break: keep-all;">
                    {{ title }}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="listaContactos" fab v-bind="attrs" v-on="on" color="primary lighten-1"
                                class="pa-5 elevation-0" rounded small>
                                <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Editar contactos</span>
                    </v-tooltip>
                </v-card-title>
                <v-col class="mx-5 py-0">
                    <v-card-actions>
                        <v-list-item-icon class="mx-3">
                            <v-icon color="red">
                                mdi-map-marker-outline
                            </v-icon>
                        </v-list-item-icon>
                        <div v-if="loadingDomicilio" class="flex-grow-1 py-2">
                            <v-skeleton-loader type="text" max-width="70%" class="mb-1" />
                            <v-skeleton-loader type="text" max-width="50%" />
                        </div>
                        <v-list-item v-else-if="domicilioPrinc && domicilioPrinc.calle">
                            <v-list-item-content class="ma-0 pa-0">
                                <v-list-item-title class="ma-0 pa-0 font-weight-bold black--text"
                                    :class="($vuetify.breakpoint.xsOnly) ? 'text-subtitle-2' : 'text-body-1'">
                                    <div style="white-space: normal; word-wrap: break-word;">
                                        {{
                                            domicilioPrinc.calle }}
                                        {{ domicilioPrinc.nro }} {{
                                            domicilioPrinc.piso }}
                                        {{
                                            domicilioPrinc.dpto
                                        }}
                                    </div>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ domicilioPrinc.localidad }}
                                    {{ domicilioPrinc.desprov }}
                                    C.P: {{ domicilioPrinc.cp }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-else>
                            <v-list-item-content>
                                <v-list-item-title class=" font-weight-regular black--text text-body-1 ">
                                    <div style="white-space: normal; word-wrap: break-word;">
                                        No hay domicilio marcados como principal.
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card-actions>
                    <v-card-actions class=" d-flex flex-row">
                        <v-list-item-icon class="mx-3">
                            <v-icon color="green">
                                mdi-phone-outline
                            </v-icon>
                        </v-list-item-icon>

                        <div v-if="loadingTelefono" class="flex-grow-1 py-2">
                            <v-skeleton-loader type="text" max-width="55%" class="mb-1" />
                            <v-skeleton-loader type="text" max-width="30%" />
                        </div>
                        <v-list-item v-else-if="telefonoPrinc && telefonoPrinc.telefono">
                            <v-list-item-content class="ma-0 pa-0">
                                <v-list-item-title class="ma-0 pa-0 font-weight-bold black--text"
                                    :class="($vuetify.breakpoint.xsOnly) ? 'text-subtitle-2' : 'text-body-1'">+{{
                                        telefonoPrinc.codpais }} ({{ telefonoPrinc.carac }}) - {{
                                        telefonoPrinc.telefono }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ telefonoPrinc.destiptelefono }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-else>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <div style="white-space: normal; word-wrap: break-word;">

                                        No hay telefono marcados como principal.
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card-actions>
                    <v-card-actions class="d-flex flex-row">
                        <v-list-item-icon class="mx-3">
                            <v-icon color="indigo">
                                mdi-email-outline
                            </v-icon>
                        </v-list-item-icon>
                        <div v-if="loadingEmail" class="flex-grow-1 py-2">
                            <v-skeleton-loader type="text" max-width="65%" class="mb-1" />
                            <v-skeleton-loader type="text" max-width="30%" />
                        </div>
                        <v-list-item v-else-if="emailPrinc && emailPrinc.email">
                            <v-list-item-content class="ma-0 pa-0">
                                <v-list-item-title>
                                    <div class="ma-0 pa-0 font-weight-bold black--text"
                                        :class="($vuetify.breakpoint.xsOnly) ? 'text-subtitle-2' : 'text-body-1'">
                                        {{ emailPrinc.email }}
                                    </div>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ emailPrinc.destipcontacto }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-else>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <div style="white-space: normal; word-wrap: break-word;">
                                        No hay email marcados como principal.
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card-actions>
                </v-col>
            </v-card>
        </v-hover>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Fab from '@/components/navigations/Fab.vue'
import DialogoEditar from '@/components/dialogos/DialogoEditar.vue'

export default {
    name: "ContactCard",
    components: {
        Fab,
        DialogoEditar
    },

    data() {
        return {
            fab: false,
            loading: false,

            //dialogo
            cabecera: '',
            itemGrid: '',
            itemsContacto: '',


        }
    },
    computed: {
        ...mapGetters(['telefono', 'email', 'domicilio', 'telefonoPrinc', 'emailPrinc', 'domicilioPrinc',
            'loadingDomicilio', 'loadingTelefono', 'loadingEmail']),
        ...mapGetters('auth', ['user']),
    },
    methods: {
        ...mapActions('common', ['getTipoContactoFiltro']),

        lanzarDialogoDom() {
            this.itemsContacto = this.domicilio
            this.itemGrid = { titulo: 'Mis domicilios', tipo: 'domicilio', icon_btn: 'mdi-map-marker-plus-outline', icon: 'mdi-map-marker-outline', color: 'red' }
            this.cabecera = [{ text: 'CALLE', value: 'calle', align: 'center', },
            { text: 'NRO.', value: 'nro', align: 'center', sortable: false },
            { text: 'PISO', value: 'piso', align: 'center', sortable: false },
            { text: 'DPTO.', value: 'dep', align: 'center', sortable: false },
            { text: 'PROVINCIA', value: 'desprov', align: 'center', sortable: false },
            { text: 'LOCALIDAD', value: 'localidad', align: 'center', sortable: false },
            { text: 'TIPO', value: 'destipcontacto', align: 'center', sortable: false },
            { text: 'PRINCIPAL', value: 'recibecorreo', align: 'center', sortable: false },
            { text: 'ACCIONES', value: 'actions', sortable: false, align: 'center' }]

            this.$refs.dialogoEdit.abrirDialog()
        },
        lanzarDialogoMail() {
            this.itemsContacto = this.email
            this.itemGrid = { titulo: 'Mis email', tipo: 'mail', icon_btn: 'mdi-email-plus-outline', icon: 'mdi-email-outline', color: 'indigo' }
            this.cabecera = [
                { text: 'EMAIL', value: 'email', align: 'center', sortable: false },
                { text: 'TIPO', value: 'destipcontacto', sortable: false, align: 'center' },
                { text: 'PRINCIPAL', value: 'recibeemail', sortable: false, align: 'center' },
                { text: 'ACCIONES', value: 'actions', sortable: false, align: 'center' },
            ],
                this.$refs.dialogoEdit.abrirDialog()
        },
        lanzarDialogoTelefono() {
            this.itemsContacto = this.telefono
            this.itemGrid = { titulo: 'Mis telefonos', tipo: 'telefono', icon_btn: 'mdi-phone-plus-outline', icon: 'mdi-map-marker-outline', color: 'red' }
            this.cabecera = [
                { text: 'COD. PAIS', value: 'codpais', align: 'center', sortable: false },
                { text: 'CARACTERISTICA', value: 'carac', align: 'center', sortable: false },
                { text: 'NUMERO', value: 'telefono', align: 'center', sortable: false },
                { text: 'TIPO CONTACTO', value: 'destipcontacto', align: 'center', sortable: false },
                { text: 'EMPRESA', value: 'destipcarrier', align: 'center', sortable: false },
                { text: 'TIPO TEL.', value: 'destiptelefono', align: 'center', sortable: false },
                { text: 'PRINCIPAL.', value: 'recibellamada', align: 'center', sortable: false },
                { text: 'ACCIONES', value: 'actions', sortable: false, align: 'center' },
            ],
                this.$refs.dialogoEdit.abrirDialog()
        },
        listaContactos() {
            this.$router.push('/ListarContactos').catch(() => { })
        },

        filtrarMail() {
            this.titulo = "mail"
            this.tipo = "mail"
            this.$refs.dialogoEdit.abrirDialog()
            this.getTipoContactoFiltro(this.email.map(e => e.destipcontacto))
            console.log(this.email.map(e => e.destipcontacto))
        },
        filtrarTelefono() {
            this.getTipoContactoFiltro(this.telefono.map(e => e.destipcontacto))
            console.log(this.telefono.map(e => e.destipcontacto))
        },
        filtrarDomicilios() {
            this.getTipoContactoFiltro(this.domicilio.map(e => e.destipcontacto))
            console.log(this.domicilio.map(e => e.destipcontacto))
        }
    },
    props: ['title']
}
</script>